import { buildClientCard } from '../../shared';

export const sellerCard = buildClientCard({
  id: 'sellerSideContacts.sellerX',
  entityType: 'client',
  label: 'Seller',
  showSameAsProperty: true,
});
